import React from 'react';
import PropTypes from 'prop-types';

import { camelCase } from 'lodash';

import styles from './ActionButtons.scss';

import actionStatuses from './Components/actionStatuses.json';

import Findtool from './Actions/Findtool/Findtool';

import ActionGenerator from './Actions/ActionGenerator';
import ActionsManager, { STATUS_NAMES } from './Actions/ActionsManager';

export { actionStatuses, Findtool, ActionsManager, STATUS_NAMES };

export const ACTION_NAMES = {
    NEW: 'new',
    DELETE: 'delete',
    DOWNLOAD: 'download',
    MORE: 'more',
};

export const ACTIONS = Object.keys(ACTION_NAMES).reduce(
    (all, action) => ({
        ...all,
        [camelCase(ACTION_NAMES[action])]: ActionGenerator(ACTION_NAMES[action]),
    }),
    { findTool: Findtool },
);

function Actions({ children }) {
    return (<div className={styles.actions} data-action-buttons>
        <div className={styles['actions-inner']}>
            {children}
        </div>
    </div>)
}

Actions.propTypes = {
    children: PropTypes.any,
};

Actions.defaultProps = {
    children: null,
};

export default Actions;
